import { fieldColors } from './consts'

const baseStyle = {
  container: {
    focusWithinRing: 3,
    color: fieldColors.inputText,
    fontSize: 'lg',
    lineHeight: '135%',
  },
  icon: {
    color: fieldColors.icons,
  },
  field: {
    placeholderTextColor: fieldColors.placeholder,
  },
  // kept for the still-existing `Input`/`Textarea` components during the deprecation window (Phase 3)
  input: {
    placeholderTextColor: fieldColors.placeholder,
  },
}

const defaultProps = {
  size: 'lg',
  variant: 'grey',
}

const parts = ['container', 'icon', 'field', 'input', 'label']

const sizes = {
  sm: {
    container: {
      fontSize: 'sm',
      h: 24,
    },
    icon: {
      size: 'xs',
    },
    field: {},
    input: {},
    label: {
      fontSize: 'sm',
    },
  },
  md: {
    container: {
      fontSize: 'md',
      h: 32,
    },
    icon: {
      size: 'sm',
    },
    field: {},
    input: {},
    label: {
      fontSize: 'md',
    },
  },
  lg: {
    container: {
      fontSize: 'md',
      h: 40,
    },
    icon: {
      size: 'md',
    },
    field: {},
    input: {},
    label: {
      fontSize: 'md',
    },
  },
  xl: {
    container: {
      fontSize: 'lg',
      h: 48,
    },
    icon: {
      size: 'lg',
    },
    field: {},
    input: {},
    label: {
      fontSize: 'md',
    },
  },
}

const variants = {
  grey: {
    container: {
      borderColor: fieldColors.border,
      focusWithinRingColor: fieldColors.focus,
    },
  },
  red: {
    container: {
      borderColor: fieldColors.error,
      focusWithinRingColor: fieldColors.error,
    },
  },
}

export default {
  baseStyle,
  defaultProps,
  parts,
  sizes,
  variants,
}
